import { Component, OnInit } from "@angular/core";
import { UtilService } from "src/app/shared/services/util.service";
import { ConstantesService } from "src/app/shared/services/constantes.service";
import * as moment from "moment";
import { UrlService } from "src/app/shared/services/url.service";
import { UrlControl } from "src/app/shared/models/generic.model";
import { GlobalService } from "src/app/shared/global.service";
import { ParametrosModel } from "src/app/models/parametros.model";
import {
  CustomDatepickerComponent,
  DatepickerComponent,
} from "src/app/shared/components/datePicker/ajustado/datepicker.component";
import { NgxSpinnerService } from "ngx-spinner";
import { AlertService } from "src/app/shared/services/alert.service";

@Component({
  selector: "app-administrar-agendamiento-virtual",
  templateUrl: "./administrar-parametros-totem-component.html",
  styleUrls: ["./administrar-parametros-totem-component.scss"],
})
export class AdministrarParametrosTotemComponent implements OnInit {
  public isValid = false;

  public customDatepickerComponent: DatepickerComponent;

  public parametroModoEntradaSalida: ParametrosModel;
  public calcularEntrada: boolean;

  public idenficadorTotem: string;
  public tipoIngreso: string;

  public totems: Array<ParametrosModel> = [];

  constructor(
    private utilService: UtilService,
    private urlService: UrlService,
    private global: GlobalService,
    private spiner: NgxSpinnerService,
    private alertService: AlertService
  ) {}

  ngOnInit() {
    //Consulta el párametro de fechas para el agendamiento virtual.
    this.consultarParametros();
  }

  private consultarParametros() {
    this.consultarTotems();

    this.obtenerValorParametro(
      ConstantesService.NOMBRE_PARAMETRO_TIPO_ENTRADA_TOTEM
    )
      .then((parametro) => {
        this.parametroModoEntradaSalida = parametro;
        if (parametro.valor === "TRUE") {
          this.calcularEntrada = true;
        }
      })
      .catch((err) => {
        //TODO
      });
  }

  /**
   * Este método se encarga de consultar el parámetro y generar un dto
   * @param nombreParametro
   * @returns retorna un parametro DTO con toda la información.
   */
  public obtenerValorParametro(
    nombreParametro: String
  ): Promise<ParametrosModel> {
    return new Promise((resolve, reject) => {
      const serviceProvider = "parametroPorNombre";
      const queryParams: Array<[string, string]> = new Array<
        [string, string]
      >();
      queryParams.push(["nombreParametro", nombreParametro.toString()]);
      const url = this.urlService.getUrlUAC(
        new UrlControl(serviceProvider, null, queryParams),
        this.urlService.hostAPI_UAC
      );
      this.global.getGenerico(url).subscribe(
        (data) => {
          let parametrosModel: ParametrosModel = data;
          resolve(parametrosModel);
        },
        (err) => {
          console.log(err);
          reject(err);
        }
      );
    });
  }

  public actualizarModo() {
    let usuario = JSON.parse(sessionStorage.getItem("Usuario"));
    this.parametroModoEntradaSalida.usuarioModificacion = usuario.userid;
    this.parametroModoEntradaSalida.fechaModificacion = new Date();

    if (this.calcularEntrada) {
      this.parametroModoEntradaSalida.valor = "TRUE";
    } else {
      this.parametroModoEntradaSalida.valor = "FALSE";
    }

    this.actualizarParametro(this.parametroModoEntradaSalida).then(() => {
      this.alertService.generateAlertSuccess("Se ha actualizado el modo", "");
    });
  }

  async agregarTotem() {
    let usuario = JSON.parse(sessionStorage.getItem("Usuario"));
    let nuevoTotemParametro: ParametrosModel = new ParametrosModel();
    nuevoTotemParametro.descripcion =
      "Totem usado para el ingreso y salida de funcionarios";
    nuevoTotemParametro.estado = "ACT";
    nuevoTotemParametro.fechaCreacion = new Date();
    nuevoTotemParametro.fechaModificacion = new Date();
    nuevoTotemParametro.usuarioModificacion = usuario;
    nuevoTotemParametro.modulo = "TRANSV";
    nuevoTotemParametro.nombre = "TOTEM " + this.idenficadorTotem;
    nuevoTotemParametro.valor = this.tipoIngreso;

    await this.crearParametro(nuevoTotemParametro);
    this.alertService.generateAlertSuccess("Se ha agregado un TOTEM", "");
    this.consultarTotems();
    this.idenficadorTotem = "";
  }

  /**
   * Ejecuta un PUT para actualizar un párametro
   *
   * @param parametrosModel retorna una promesa de la actualización de un parámetro
   * @returns
   */
  private actualizarParametro(
    parametrosModel: ParametrosModel
  ): Promise<ParametrosModel> {
    return new Promise((resolve, reject) => {
      try {
        let usuario = JSON.parse(sessionStorage.getItem("Usuario"));
        parametrosModel.usuarioModificacion = usuario.userid;
        parametrosModel.fechaModificacion = new Date();
        const serviceProvider = "ObtenerParametros";
        const url = this.urlService.getUrlUAC(
          new UrlControl(serviceProvider, null, null),
          this.urlService.hostAPI_UAC
        );
        this.global.putGenerico(url, parametrosModel).subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            this.spiner.hide();
            this.alertService.generateAlertError(error.message, "Error");
            reject();
          }
        );
      } catch (error) {
        this.spiner.hide();
        this.alertService.generateAlertError(error.message, "Error");
      }
    });
  }

  cleanTotemName(nombre: string): string {
    return nombre.split("TOTEM ")[1];
  }

  /**
   *
   *
   * @param parametrosModel retorna una promesa de la actualización de un parámetro
   * @returns
   */
  private crearParametro(
    parametrosModel: ParametrosModel
  ): Promise<ParametrosModel> {
    return new Promise((resolve, reject) => {
      try {
        let usuario = JSON.parse(sessionStorage.getItem("Usuario"));
        parametrosModel.usuarioModificacion = usuario.userid;
        parametrosModel.fechaModificacion = new Date();
        const serviceProvider = "ObtenerParametros";
        const url = this.urlService.getUrlUAC(
          new UrlControl(serviceProvider, null, null),
          this.urlService.hostAPI_UAC
        );
        this.global.postGenerico(url, parametrosModel).subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            this.spiner.hide();
            this.alertService.generateAlertError(error.message, "Error");
            reject();
          }
        );
      } catch (error) {
        this.spiner.hide();
        this.alertService.generateAlertError(error.message, "Error");
      }
    });
  }

  /**
   * Obtiene un listado totems
   * @returns promesa de arreglo de totems
   */

  private consultarTotems() {
    const serviceProvider = "parametroTotem";
    const url = this.urlService.getUrlUAC(
      new UrlControl(serviceProvider, null, null),
      this.urlService.hostAPI_UAC
    );
    this.global.getGenerico(url).subscribe(
      (data) => {
        this.totems = data;
      },
      (err) => {
        console.log(err);
        this.alertService.generateAlertError(
          "No es posible obtener totems",
          "Error"
        );
      }
    );
  }

  /**
   * Consume servicio post al api UAC para eliminar el totem.
   * @param date fecha
   */
  public eliminarTotem(nombreTotem: string) {
    this.spiner.show();

    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(["nombreParametro", nombreTotem.toString()]);

    const serviceProvider = "eliminarParametroTotem";
    const url = this.urlService.getUrlUAC(
      new UrlControl(serviceProvider, null, queryParams),
      this.urlService.hostAPI_UAC
    );

    this.global.postGenerico(url).subscribe(
      (data) => {
        this.alertService.generateAlertSuccess("Se ha eliminado un TOTEM", "");
        this.consultarTotems();
        this.spiner.hide();
      },
      (err) => {
        console.log(err);
        this.alertService.generateAlertError(err.error.message, "Error");
        this.spiner.hide();
      }
    );
  }
}
